import { styled, typography } from '@pulse-web-ui/theme';

export const AgentProfileWrapper = styled.div`
  max-width: 768px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Label = styled.h4`
  ${typography.regular12};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
`;

export const Value = styled.p`
  ${typography.regular16};
  margin: 0;
  line-height: 24px;
  flex: 1;
`;

export const SupportLinkHintContainer = styled.div`
  margin-top: 10px;
`;

export const DescriptionText = styled.p`
  ${typography.regular16}
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 0;
  margin-bottom: 24px;
`;

export const SectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
